import { useKeyDown } from '../useKeyDown/useKeyDown.esm.js';
import { useClickOutside } from '../../../common/hooks/useClickOutside/useClickOutside.esm.js';

function useCloseableElement(element, active, callback) {
    useKeyDown("Escape", active, callback);
    useClickOutside(element, active, callback);
}

export { useCloseableElement };
